'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';
import cx from 'classnames';
import { NAV_MODAL_ID } from '@pyranger/constants';

import type { ArticleCardData } from '@pyranger/types';

/**
 * An individual card for a Lesson or Project.
 * @param data a {@link ArticleCardData} object
 */
export const ArticleCard = ({
    description,
    href,
    imageUrl,
    slug,
    title,
}: ArticleCardData) => {
    const pathname = usePathname();
    const selected = slug && pathname.includes(slug);

    return (
        <li>
            <Link
                href={href}
                className={cx(
                    'flex w-[240px] flex-col gap-4 rounded-lg border border-accent-content p-4 text-base-content no-underline xl:w-[526px] xl:flex-row',
                    {
                        'bg-base-100': selected,
                        'hover:bg-base-200': !selected,
                    },
                )}
                onClick={() => {
                    const modal = document.querySelector<HTMLDialogElement>(
                        `#${NAV_MODAL_ID}`,
                    );

                    if (modal) {
                        modal.close();
                    }
                }}
            >
                <div
                    className={`relative h-[148px] w-[208px] flex-none rounded-lg bg-base-200`}
                >
                    {imageUrl && (
                        <Image
                            src={imageUrl}
                            alt={title}
                            fill
                            // Make sure this matches the width applied to the containing div
                            sizes="208px"
                            className="rounded-lg bg-white object-cover"
                            priority
                        />
                    )}
                </div>
                <div>
                    <h3 className="break-words font-display text-lg font-semibold">
                        {title}
                    </h3>
                    {description}
                </div>
            </Link>
        </li>
    );
};
